import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import AuthSentNotice from '../components/auth/AuthSentNotice';
import EmailRequestForm from '../components/auth/EmailRequestForm';
import SignInMethodsLoading from '../components/auth/SignInMethodsLoading';
import { AUTH_LINK_CLASSES } from '../components/auth/authLinkClasses';
import { useAuthStore } from '../store/authStore';
import { useSignInMethods } from '../hooks/useSignInMethods';
import { Panel } from '../components/ui/Panel';

export default function ForgotPasswordPage() {
    const { sendPasswordReset } = useAuthStore();
    const [sentTo, setSentTo] = useState<string | null>(null);
    const methods = useSignInMethods();

    return (
        <AuthLayout tagline="Get back to your fleet" focus="task">
            <Panel variant="glass" padding="lg" className="flex flex-col gap-3">
                <h2 className="text-heading text-content-primary">{sentTo ? 'Check your inbox' : 'Reset your password'}</h2>

                {!methods ? (
                    <SignInMethodsLoading />
                ) : !methods.emailPassword ? (
                    <p className="text-body text-content-secondary">
                        Password sign-in isn&apos;t available right now, so there is no password to reset.
                    </p>
                ) : sentTo ? (
                    <AuthSentNotice>
                        If an account exists for <span className="font-semibold text-content-primary">{sentTo}</span>,
                        we&apos;ve sent it a link to choose a new password. It can take a minute, and may land in spam.
                    </AuthSentNotice>
                ) : (
                    <>
                        <p className="text-body text-content-secondary">
                            Enter the email you signed up with and we&apos;ll send you a link to choose a new password.
                        </p>
                        <EmailRequestForm
                            submitLabel="Send reset link"
                            onSubmit={async (email) => {
                                await sendPasswordReset(email);
                                setSentTo(email);
                            }}
                        />
                    </>
                )}

                <p className="mt-4 text-body">
                    <Link to="/login" className={AUTH_LINK_CLASSES}>
                        Back to sign in
                    </Link>
                </p>
            </Panel>
        </AuthLayout>
    );
}
